import FormularioSuplantacionIdentidad from '../../components/suplantacionidentidad/FormularioSuplantacionIdentidad';

const SuplantacionIdentidad = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Simular usuario</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Busca por nombre o email y navega la app como otro usuario
      </p>
    </div>
    <FormularioSuplantacionIdentidad />
  </div>
);

export default SuplantacionIdentidad;
